import { useRef } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Returns true if the given search param was present at any point during
 * this component's mount. Latches to true on first sight so transient URL
 * changes (e.g. a callee stripping the param) don't flip the result back.
 */
export function useHasSearchParam(param: string): boolean {
  const [searchParams] = useSearchParams();
  const seen = useRef(false);
  if (!seen.current && searchParams.get(param)) {
    seen.current = true;
  }
  return seen.current;
}
